// extracted by mini-css-extract-plugin
module.exports = {"defaultIcon":"MyAvatar_defaultIcon__rYCLM"};